export const SITE_URL = process.env.REACT_APP_SITE_URL || 'http://localhost:9000';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
